import React, {useState} from 'react';
import numeral from 'numeral';
import classNames from 'classnames';
import {getMPPEndpoint, getHeaders} from '../../../../../../helpers/endpoint';
import {useDispatch} from 'react-redux';
import Loader from '../../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import moment from 'moment';
import './index.css';
import {challengesStatus} from '../../../../../../helpers/league';
import {BOGetContestsSummaryResponse} from '@fantaleague/mpp_types';

export interface IChallengesStats {
  [key: string]: {
    min: number;
    max: number;
    average: number;
    users: number;
  };
}

const LeaguesStatsByStatus = () => {
  const dispatch = useDispatch();

  const [lang, setLang] = useState('fr-FR');
  const [startDate, setStartDate] = useState(
    moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD'),
  );
  const [leagueStats, setLeagueStats] = useState<
    BOGetContestsSummaryResponse | undefined
  >(undefined);
  const [challengesStats, setChallengesStats] = useState<
    BOGetContestsSummaryResponse | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getContestsByStatus = () => {
    return (_dispatch, getState) => {
      setIsLoading(true);
      return Promise.all([
        fetch(
          getMPPEndpoint('getContestsStatsByStatus', {
            contestType: 'challenge',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
        fetch(
          getMPPEndpoint('getContestsStatsByStatus', {
            contestType: 'league',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
      ])
        .then(([challengeData, leagueData]) => {
          setLeagueStats(leagueData);
          setChallengesStats(challengeData);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    };
  };

  const renderTable = (
    contestType: BOGetContestsSummaryResponse,
    id: string,
  ) => {
    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Ligue</th>
              <th className="text-center">Nombre</th>
              <th className="text-center">%</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(contestType).map(([category, values]) => {
              const title = challengesStatus?.[category];
              return (
                <tr
                  key={`${id}-${category}`}
                  data-toggle="collapse"
                  data-target={`.${id}-${category}`}>
                  <td style={{width: '150px '}}>{title}</td>
                  <td className="text-center">
                    <b>{values.totalContests}</b>
                  </td>
                  <td className="text-center">
                    {numeral(values.percentage).format('0')}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const renderLeaguesByModeByStatus = () => {
    if (!leagueStats || !challengesStats) {
      return null;
    }
    const contestsStats = Object.values({challengesStats, leagueStats}).map(
      element => {
        return element;
      },
    );

    return contestsStats.map((contestType, index) => {
      const id = `leaguesByModeByStatus-${index}`;
      return (
        <div key={id} id={id} className="mb-4">
          <h3 className="my-0 ml-3">{index === 0 ? 'Classique' : '1vs1'}</h3>
          {renderTable(contestType, id)}
        </div>
      );
    });
  };

  return (
    <div className="leagues-stats-widget">
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-hourglass" /> Ligues par statut
          </h3>
          <br />
          Dernier statut des ligues le {endDate}, par mode, par nombre de joueur
        </div>
        <div className="box-body">
          <div className="text-center">
            <div className="inline lang">
              <button
                className={classNames('btn btn-box-tool', {
                  selected: lang === 'fr-FR',
                })}
                onClick={() => setLang('fr-FR')}>
                <span className="flag-icon flag-icon-fr" />
              </button>
            </div>
            <div className="period-filter inline data-range-picker">
              <DateRangePickerWrapper
                initialStartDate={moment(startDate)}
                initialEndDate={moment(endDate)}
                minimumNights={0}
                onDatesChange={({startDate, endDate}) => {
                  setStartDate(moment(startDate).format('YYYY-MM-DD'));
                  setEndDate(moment(endDate).format('YYYY-MM-DD'));
                }}
              />
              <button
                className="mb-1 inline btn btn-default btn-flat"
                onClick={() => {
                  dispatch(getContestsByStatus());
                }}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
        </div>
        {isLoading && <Loader />}
        {renderLeaguesByModeByStatus()}
      </div>
    </div>
  );
};

export default LeaguesStatsByStatus;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/components/LeaguesStatsByStatus/index.tsx